module.exports = __webpack_public_path__ + "img/boss-bg.b83dec36.jpg";